import angular from 'angular';
import ServicesModule from '../../../services/services';
import ResourcesModule from '../../../resources/resources';
import template from './gamesIndex.jade';

export class GamesIndexController {
  /* @ngInject */
  constructor($window, $filter, $stateParams, $state, $q, GamesV2Resource, GameDevelopersResource, ggPaginatedTable) {
    this.$window = $window;
    this.translateWith = $filter('translateWith');
    this.GamesV2Resource = GamesV2Resource;
    this.GameDevelopersResource = GameDevelopersResource;
    this.$state = $state;
    this.gamesStatusFilterValue = $stateParams.gamesStatusFilterValue || 'active';
    this.sortByValues = {
      rank_as_buyer: 'rankAsBuyer',
      rank_as_seller: 'rankAsSeller',
    };
    this.resourcesTable = new ggPaginatedTable({count: 30, getData: this.getData});
    this.$q = $q;
    this.disposables = [];
    this.games = [];
    this.gameDevelopers = [];
    this.search = '';
    this.user;
    this.resetPages = false;
  }

  enrichGames(games, gameDevelopers) {
    _.forEach(games, (game) => {
      game.gameDeveloperName = _.chain(gameDevelopers).filter(gd => gd.id === game.game_developer_id).map('company_name').value()[0];
    });
  }

  loadGames = ($defer, params, csv, cols) => {
    let sort_by = null;
    let sort_direction = null;
    if (!_.isEmpty(params.orderBy())){
      const orderBy = params.orderBy()[0];
      sort_by = this.sortByValues ? this.sortByValues[orderBy.substring(1)] || orderBy.substring(1) : orderBy.substring(1);
      sort_direction = orderBy.charAt(0) === '+' ? 'ASC' : 'DESC';
    }
    this.GamesV2Resource.one().get({page: this.resetPages ? 1 : params.page(), count: params.count(), sort_by, sort_direction, search_term: this.search, status: this.getStatusFilter()}).then((response) => {
      this.games = response.items;
      this.enrichGames(this.games, this.gameDevelopers);
      params.total(response.total_elements);
      csv && csv.loadTableData(cols, this.games);
      this.resetPages = false;
      return $defer.resolve(this.games);
    });
  }

  getData = ($defer, params, csv, cols) => {
    if (_.isEmpty(this.gameDevelopers)) {
      this.GameDevelopersResource.getList().then(gameDevelopers => {
        this.gameDevelopers = gameDevelopers;
        this.loadGames($defer, params, csv, cols);
      })
    } else {
      this.loadGames($defer, params, csv, cols);
    }
  }

  remove(resource) {
    if (!this.$window.confirm(this.translateWith('confirmDelete', resource.name)))
      return false;

    resource.remove();
    this.resourcesTable.remove(resource);
  }

  onSearchChange() {
    this.resetPages = true;
    this.resourcesTable.reload();
  }

  getStatusFilter() {
    if (this.gamesStatusFilterValue === 'active') {
      return 'Active';
    } else if (this.gamesStatusFilterValue === 'inactive') {
      return 'Inactive';
    }
    return null;
  }

  updateGamesByStatus(status) {
    this.gamesStatusFilterValue = status;
    this.$state.go('mirror', { extraParam: 'gamesStatusFilterValue--' + status });
  }
}

let GamesIndexComponent = {
  template: ($element, $attrs) => { return template; },
  controller: GamesIndexController,
  controllerAs: 'vm',
  bindings: {
    title: '='
  }
};

export default angular.module('app.components.admin.games.index', [
  ServicesModule.name,
  ResourcesModule.name
])
.component('adminGamesIndex', GamesIndexComponent);



/** WEBPACK FOOTER **
 ** ./src/components/admin/games/gamesIndex.js
 **/